import { TableSchema } from '../metadata-schema';

export const instelling: TableSchema = {
	"$schema": "https://json-schema.org/draft/2020-12/schema",
	"title": "instelling",
	"description": "Definitie voor sys tabel instelling uit de CumLaude sys",
	"type": "object",
	"implements": [
		"nl.topicus.cumlaude.metadata.table.SysTable",
		"nl.topicus.cumlaude.metadata.table.Landelijk"
	],
	"abbrev": "inst",
	"properties": {
		"inst_nm_bron": {
			"type": "string",
			"filter": false,
			"grouping": false,
			"exportable": false
		},
		"inst_nm_instelling": {
			"type": "string",
			"label": "Instelling",
			"category": "School",
			"example": "CumLaude College"
		}
	}
};
